import React, { useState } from "react";

import { useAppDispatch } from "../../../../redux/hooks";

import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import CustomButton from "../../../../components/CustomButton";
import TextInput from "../../../../components/misc/TextInput";
import ModalWrapper from "../../../../components/Modal/ModalWrapper";

import {
  TableContextType,
  TableItemType,
} from "../../../../components/tables/tableContext/TableContext";
import { TableItemId } from "../../../../components/tables/TableWidget";
import { ReturnProductDataInterface } from "../../../../redux/interfaces/returning.interface";
import { postPdfPredarePrimire } from "../../../../redux/api/returning.api";

function ReturnDifferencesActionButton({
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData: ReturnProductDataInterface;
  tableContext?: TableContextType;
}) {
  const dispatch = useAppDispatch();

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [reason, setReason] = useState<string | number | null>(null);

  const handleClosePdfModal = () => {
    setShowPdfModal(false);
    setReason(null);
  };

  const disableSaveButton = !reason?.toString().trim();

  const handleDownloadPdf = async () => {
    if (disableSaveButton || !reason) {
      return;
    }

    setIsLoadingSave(true);

    try {
      await dispatch(
        postPdfPredarePrimire({
          ...crudData,
          reason: reason,
        }),
      );
      handleClosePdfModal();
    } finally {
      setIsLoadingSave(false);
    }
  };

  return (
    <div>
      <ActionMenu
        minItemsForMenu={2}
        title={crudData.numeProdus}
        ariaLabel={`Actiuni pentru produsul ${crudData.numeProdus}`}
        items={[
          {
            id: "download-pv",
            label: "Descarca PV",
            icon: "PRINT",
            kind: "download",
            tooltip:
              crudData?.diferenta === 0
                ? "Nu exista diferente de cantitate pentru generarea procesului-verbal."
                : !crudData?.cantWms
                ? "Procesul-verbal nu poate fi generat fara o cantitate receptionata in WMS."
                : "Deschide completarea motivului pentru generarea si descarcarea procesului-verbal.",
            disabled: !(crudData?.diferenta !== 0 && crudData?.cantWms),
            onClick: () => setShowPdfModal(true),
          },
        ]}
      />

      <ModalWrapper
        title="Download pv predare-primire"
        show={showPdfModal}
        handleClose={handleClosePdfModal}>
        <TextInput
          className="mb-4"
          label="Motiv"
          name="reason"
          id="reason"
          value={reason}
          onChange={(value) => setReason(value)}
          autoFocus
        />
        <div className="flex justify-end">
          <CustomButton
            variant="contained"
            onClick={handleDownloadPdf}
            loading={isLoadingSave}
            disabled={disableSaveButton}>
            Download PDF
          </CustomButton>
        </div>
      </ModalWrapper>
    </div>
  );
}

export default ReturnDifferencesActionButton;
